import { render, staticRenderFns } from "./commercialQrType.vue?vue&type=template&id=455ff708&scoped=true"
import script from "./commercialQrType.vue?vue&type=script&lang=js"
export * from "./commercialQrType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455ff708",
  null
  
)

export default component.exports